
export class ContactsInfoModel {
    code: string;
    username: string;
    description: string;
    contact: string;

    /**
     * 
     * @param code 
     * @param username 
     * @param description 
     * @param contact 
     */
    constructor( code: string, username: string, description: string, contact: string) {
        this.code = code;
        this.username = username;
        this.description = description;
        this.contact = contact;
    }
}